
<div class="dtf-olp" style="background-color: #E6E6E6;">
    <div class="container_dashboard">
        <div class="dtf-dashboard" style="padding-top: 41px; padding-bottom: 0px;">
          <div class="example-button-row">
            <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState" (change)="onChangeButton($event)">
              <mat-button-toggle  [value]="toggleEnum.Option7" [class.selected]="selectedState === toggleEnum.Option7">Make a Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option1" [class.selected]="selectedState === toggleEnum.Option1">Principal Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option3" [class.selected]="selectedState === toggleEnum.Option3">Statement Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option6" [class.selected]="selectedState === toggleEnum.Option6">Recurring Payment</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option4" [class.selected]="selectedState === toggleEnum.Option4" style="background-color: #00566A !important; color: white !important;">Manage Bank Profile</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option2" [class.selected]="selectedState === toggleEnum.Option2">Payment History</mat-button-toggle>
              <mat-button-toggle  [value]="toggleEnum.Option8" [class.selected]="selectedState === toggleEnum.Option8">Help</mat-button-toggle>
            </mat-button-toggle-group>
            </div>
        </div> 
      </div>
    <div *ngIf="blocked">
        <dtf-errorhandling [blocked]="blocked" [errorMessage]="errmsg"></dtf-errorhandling>
    </div>
    
    <div class="container_dashboard">
        <div class="dtf-sub-dashboard container_dashboard"> 
           

            <div *ngIf="status === 'loading' && savingProfile" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
               
                <div class="demo-container">
                  <span>{{ 'Invoice.Loading' | translate }}</span>
                  <div class="progress-bar">
                    <div class="progress-bar-value"></div>
                  </div>
                </div>
                <br>
              </div>   
        
            <div *ngIf="step1" class="card">
            <h1 style="margin-bottom: 0px;">Add Bank Profile</h1>
            <div *ngIf="step1">
                <div class="row">
                    <div class="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                        <div class="pageStyle paragrapSpace">
                            {{ADDPROFILETEXT}}
                        </div>
                        <div class="pageStyle paragrapSpace body_required" *ngIf="correctInfo">
                            {{CORRECTINFORMATION}}
                        </div>
                        <div class="pageStyle paragrapSpace body_required">
                            <ul class="body_required">
                                <li class="body_required" *ngIf="invalid">{{MANADATORYTEXT}}</li>
                                <li class="body_required" *ngIf="inValidBankRoutingNum">{{INVALIDROUTINGNUM}}</li>
                                <li class="body_required"*ngIf="invalidEmail">{{EMAILVALIDATION}}</li>
                                <li class="body_required" *ngIf="invalidConfirmEmail">{{CONFIRMEMAILVALIDATION}}</li>
                                <li class="body_required" *ngIf="invalidAccountNumber">{{INVALIDACCOUNTNUMBER}}</li>
                                <li class="body_required" *ngIf="consecutiveNum">{{INVALIDACCOUNTNUMBERPATTERN}}</li>
                                <li class="body_required" *ngIf="errormsg">Invalid Bank Account and Routing Number Combination. Please verify your information and try again, or contact your bank for assistance.</li>
                                <li class="body_required"*ngIf="this.form.controls.nameOnBankAcct.errors?.pattern && submitted">Invalid entry, Special characters are not permitted, and at least one alphabetic character is required.</li>

                            </ul>
                        </div>
                        <div class="pageStyle text_align_right" style="float: right;">
                            <span class="body_required">*</span> = required.
                        </div>
                        <br>
                        <form [formGroup]="form" (ngSubmit)="onSubmit()">
                            <div style="margin-left:3%;">
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-3 col-xs-6 title"><span
                                            class="body_required">*</span>Bank Routing Number</div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                        <input matInput type="text" class="inputText" style="width:150px;" maxlength="9" formControlName="routingNum"
                                            (change)="getBankName()" onkeypress="return event.charCode >= 48 && event.charCode <= 57" />
                                        <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" alt="" style="margin-left:5px;"
                                            *ngIf="(errorArr.routingNum  && submitted) || inValidBankRoutingNum">
                                    </div>
                        
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-3 col-xs-6 title"><span class="body_required">*</span>Bank Account Type
                                    </div>
                                    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-3 lightcon">
                                        <input type="radio" name="acctType" value="C" formControlName="acctType" /> Checking
                                        <input type="radio" name="acctType" value='S' formControlName="acctType" /> Saving
                                        <input type="radio" name="acctType" value='CC' formControlName="acctType" /> Corporate Checking
                                        <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" alt="" style="margin-left:5px;"
                                            *ngIf="errorArr.acctType && submitted">
                                    </div>
                        
                        
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-3 col-xs-6 title"><span class="body_required">*</span>Bank Name</div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                        <input matInput type="text" class="inputText" style="width:150px;" readonly
                                            formControlName="bankName" />
                                        <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" alt="" style="margin-left:5px;"
                                            *ngIf="errorArr.bankName && submitted">
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-3 col-xs-6 title"><span class="body_required">*</span>Bank Account
                                        Number</div>
                                    <div class="col-lg-6 col-md-6 col-sm-4 col-xs-6 lightcon" style="display: flex;">
                                        <input matInput type="password" #password1 class="inputText" style="width:150px;" size="30" maxlength="17"
                                            formControlName='acctNum' onkeypress="return event.charCode >= 48 && event.charCode <= 57" /> &nbsp;&nbsp;
                                        <div class="input-group-append" style="max-height: 38px;" (click)="changeType(password1, hide)">
                                            <span class="input-group-text"><i [ngClass]="hide ? 'fas fa-eye' : 'fas fa-eye-slash'"></i></span>
                                        </div>
                                        <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" alt="" style="margin-left:5px;"
                                            *ngIf="errorArr.acctNum && submitted || invalidAccountNumber || consecutiveNum">
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-3 col-xs-6 title"><span class="body_required">*</span>Name On Bank
                                        Account</div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                        <div>
                                            <input matInput type="text" class="inputText" style="width:150px;" maxlength="30" size="30"
                                                formControlName='nameOnBankAcct' />
                                            <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" alt="" style="margin-left:5px;"
                                                *ngIf="form.controls.nameOnBankAcct.invalid && submitted || errorArr.nameOnBankAcct && submitted">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-4 col-md-4 col-sm-3 col-xs-6 title"></div>
                                    <div class="col-lg-8 col-md-8 col-sm-8 col-xs-8 label">
                                        <div>
                                            (<b>Please note: </b> You must be an Authorized Signer and User for the Bank Account listed. Special characters are not allowed. This field is for display purposes only and does not alter your legal name on record.)
                                        </div>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-3 col-xs-6 title"><span class="body_required">*</span>Email Address
                                    </div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                        <div>
                                            <input matInput type="text" class="inputText" style="width:150px;" maxlength="50" size="30"
                                                formControlName='email' />
                                            <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" alt="" style="margin-left:5px;"
                                                *ngIf="form.controls.email.invalid && submitted || (errorArr.email && submitted) || invalidEmail">
                                        </div>
                                    </div>
                                </div>
                                <div class="row form-group">
                                    <div class="col-lg-4 col-md-4 col-sm-3 col-xs-6 title"><span class="body_required">*</span>Confirm Email
                                        Address</div>
                                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                                        <div>
                                            <input matInput type="text" class="inputText" style="width:150px;" maxlength="50" size="30"
                                                onpaste="return false;" formControlName='emailConfirm' />
                                            <img src="static/assets/img/dtf-assets/images/redesign/required_box.gif" alt="" style="margin-left:5px;"
                                                *ngIf="form.controls.emailConfirm.invalid && submitted || (errorArr.emailConfirm && submitted) || invalidConfirmEmail">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12 mt-4">
                                        <input matInput style="margin-left:5px" type="checkbox" name="Save this profile for future payments."
                                            formControlName="saveProfile" value="saveProfile" checked /> <span style="margin-left:10px"
                                            class="label">Save this profile for future payments </span>
                                    </div>
                                </div>                  
                                <div style="display:flex;flex-direction: row;gap:10px" class="mt-4">
                                    <div style="padding-left: 2px;">
                                        <button type="submit" value="Continue >" class="mbfs-button">Continue ></button>
                                    </div>
                                    <div><button type="button" value="Cancel >" class="mbfs-button" routerLink="/home/bankprofile">Cancel ></button>
                                    </div>
                                    <div *ngIf="status === 'loading'">Please wait. We are validating your information</div>
                                </div>
                            </div>
                        </form>
                </div>
                 </div>
            </div>
            </div>
        </div>

        <div *ngIf="beforestep2">
            <div class="card">
                <h1>Add Bank Profile Verification</h1>
                <br>
                <p>Please review the information below before submitting your bank profile information.</p>
                <br>
                <div class="row" style="margin-top: 5px;">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                        Bank Name
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                        {{form.value.bankName}}
                    </div>
                </div>
                <div class="row" style="margin-top: 5px;">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                        Bank Account Type
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                        {{addBankProfile.acctDescription}}
                    </div>
                </div>
                <div class="row" style="margin-top: 5px;">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                        Bank Account Number
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                        xxxxxxxxx{{form.value.acctNum | slice:-4}}
                    </div>
                </div>
                <div class="row" style="margin-top: 5px;">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                        Bank Routing Number
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                        xxxxx{{form.value.routingNum | slice:-4}}
                    </div>
                </div>
                <div class="row" style="margin-top: 5px;">
                    <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                        Email Address
                    </div>
                    <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                        {{form.value.email}}
                    </div>
                </div>
            </div>
            <br>
            <div style="display:flex;flex-direction: row;gap:10px" class="mt-4">
                  <div *ngIf="agentview ==='true'">
                     <button class="mbfs-button" disabled>Continue</button>
                    </div>
                    <div *ngIf="agentview !='true'">
                        <button class="mbfs-button" (click)="onSubmitVerification()">Continue</button>
                    </div>
                <button class="mbfs-button" (click)="Cancel()">Cancel</button>
                <div *ngIf="savingProfile">Please wait. We are saving your information</div>
            </div>
        </div>
           
    <div *ngIf="continue">
        <div class="card">
            <h1>Add Bank Profile Confirmation</h1>
            <p>Thank you for using the Online Payment Service. Your profile has been added.</p>
            <br>
            <div class="row" style="margin-top: 5px;">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                    Bank Name
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                    {{form.value.bankName}}
                </div>
            </div>
            <div class="row" style="margin-top: 5px;">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                    Bank Account Type
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                    {{addBankProfile.acctDescription}}
                </div>
            </div>
            <div class="row" style="margin-top: 5px;">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                    Bank Account Number
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                    xxxxxxxxx{{form.value.acctNum | slice:-4}}
                </div>
            </div>
            <div class="row" style="margin-top: 5px;">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                    Bank Routing Number
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                    xxxxx{{form.value.routingNum | slice:-4}}
                </div>
            </div>
            <div class="row" style="margin-top: 5px;">
                <div class="col-lg-3 col-md-3 col-sm-3 col-xs-6 title">
                    Email Address
                </div>
                <div class="col-lg-4 col-md-4 col-sm-4 col-xs-6 lightcon">
                    {{form.value.email}}
                </div>
            </div>
        </div>
        <br>
        <!-- <button class="mbfs-button" (click)="back()">Back</button> -->
        <button class="mbfs-button" (click)="downloadPDF()">Print</button>
        <button class="mbfs-button" (click)="Done()">Done</button>
    
    </div>
</div>
